var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarsign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0666504,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E6F8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.468438,
    y: 0.401787,
    width: 43.1964,
    height: 43.1964,
    rx: 21.5982,
    stroke: "#09B81D",
    strokeOpacity: 0.1,
    strokeWidth: 0.803575
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0667 12.1196C22.2682 12.1196 22.4616 12.1997 22.6041 12.3422C22.7466 12.4848 22.8267 12.6781 22.8267 12.8797V14.1464H27.1335C27.3351 14.1464 27.5284 14.2265 27.671 14.369C27.8135 14.5115 27.8936 14.7048 27.8936 14.9064C27.8936 15.108 27.8135 15.3013 27.671 15.4438C27.5284 15.5864 27.3351 15.6664 27.1335 15.6664H22.8267V21.24H24.6001C25.7424 21.24 26.8378 21.6938 27.6455 22.5015C28.4532 23.3091 28.907 24.4046 28.907 25.5469C28.907 26.6891 28.4532 27.7846 27.6455 28.5923C26.8378 29.3999 25.7424 29.8537 24.6001 29.8537H22.8267V31.1204C22.8267 31.322 22.7466 31.5153 22.6041 31.6578C22.4616 31.8004 22.2682 31.8805 22.0667 31.8805C21.8651 31.8805 21.6718 31.8004 21.5292 31.6578C21.3867 31.5153 21.3066 31.322 21.3066 31.1204V29.8537H15.9864C15.7848 29.8537 15.5915 29.7736 15.449 29.6311C15.3065 29.4886 15.2264 29.2952 15.2264 29.0937C15.2264 28.8921 15.3065 28.6988 15.449 28.5562C15.5915 28.4137 15.7848 28.3336 15.9864 28.3336H21.3066V22.7601H19.5332C18.391 22.7601 17.2955 22.3063 16.4878 21.4986C15.6801 20.6909 15.2264 19.5955 15.2264 18.4532C15.2264 17.311 15.6801 16.2155 16.4878 15.4078C17.2955 14.6001 18.391 14.1464 19.5332 14.1464H21.3066V12.8797C21.3066 12.6781 21.3867 12.4848 21.5292 12.3422C21.6718 12.1997 21.8651 12.1196 22.0667 12.1196ZM21.3066 15.6664H19.5332C18.7941 15.6664 18.0853 15.9601 17.5627 16.4827C17.04 17.0053 16.7464 17.7141 16.7464 18.4532C16.7464 19.1923 17.04 19.9012 17.5627 20.4238C18.0853 20.9464 18.7941 21.24 19.5332 21.24H21.3066V15.6664ZM22.8267 22.7601V28.3336H24.6001C25.3392 28.3336 26.048 28.04 26.5707 27.5174C27.0933 26.9948 27.3869 26.286 27.3869 25.5469C27.3869 24.8078 27.0933 24.0989 26.5707 23.5763C26.048 23.0537 25.3392 22.7601 24.6001 22.7601H22.8267Z",
    fill: "#09B81D",
    stroke: "#09B81D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarsign);
export default __webpack_public_path__ + "static/media/dollarsign.ad90ae7eb97fb2f0ef22f2dbf1afd29d.svg";
export { ForwardRef as ReactComponent };